import { FormCode } from '@kistill/shared/types'
import MoreVert from '@mui/icons-material/MoreVert'
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Grid,
  Tooltip,
} from '@mui/material'
import { DocumentType } from '@kistill/shared/types'

interface ListActionsProps {
  onCreate?: () => void
  handleClick: (event: React.MouseEvent<HTMLElement>) => void
  anchorEl: HTMLElement | null
  type: string
  openMenu: boolean
  handleClose: () => void
  handleDocumentAndClose: (enumType: DocumentType) => void
  constOpenStickerPopUp: () => void
  onOpenChangeLocationClick: () => void | Promise<void>
  selectedCount: number
  handleOpenItemFiltering: () => void
}

export function ListActions({
  handleClick,
  anchorEl,
  type,
  openMenu,
  handleClose,
  handleDocumentAndClose,
  constOpenStickerPopUp,
  onOpenChangeLocationClick,
  handleOpenItemFiltering,
  selectedCount,
}: ListActionsProps) {
  return (
    <Grid container justifyContent={'flex-end'}>
      <Grid item>
        <Tooltip title='Sækja skjöl'>
          <IconButton onClick={handleClick} aria-label='Sækja skjöl'>
            <MoreVert fontSize='large' />
          </IconButton>
        </Tooltip>
        <Menu anchorEl={anchorEl} open={openMenu} onClose={handleClose}>
          <MenuItem
            onClick={() => handleDocumentAndClose(DocumentType.Excel)}
          >
            Sækja excel skjal
          </MenuItem>
          <MenuItem
            onClick={() => handleDocumentAndClose(DocumentType.Word)}
          >
            Sækja word skjal
          </MenuItem>
          {(Object.values(FormCode).includes(type as FormCode) ||
            type === 'items') && (
            <Box>
              <Divider />
              <MenuItem onClick={() => constOpenStickerPopUp()}>
                Sækja límmiða
              </MenuItem>
              {selectedCount > 0 &&
                (type === 'items' ||
                  type === 'KVIKS' ||
                  type === 'GOGNGR' ||
                  type === 'GOGN' ||
                  type === 'SAFNMUN') && (
                  <Box>
                    <Divider />
                    <MenuItem onClick={() => onOpenChangeLocationClick()}>
                      Breyta staðsetningu á völdum eintökum
                    </MenuItem>
                  </Box>
                )}
            </Box>
          )}
          {selectedCount > 0 &&
            (type === 'origin' || type === 'itemCollection') && (
              <MenuItem onClick={() => handleOpenItemFiltering()}>
                Birta eintök valinna {type === 'origin' ? 'uppruna' : 'aðfanga'}
              </MenuItem>
            )}
        </Menu>
      </Grid>
    </Grid>
  )
}
